import React, { useState, useEffect, useRef } from "react";
import Tooltip from "./Tooltip";
import Select from "./Select";
import SaveButtons from "./SaveButtons";
import { getCurrency } from "../../utils/helper";

const FulfillmentandStorage = ({ data, handleUpdate, settings }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [properties, setProperties] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const inputRefs = useRef([]);

  const local_dropdownOptions = ["FBA", "FBM"];
  const euro_dropdownOptions = ["EFN", "Pan EU"];

  const handleChange = (e, idx) => {
    let value;

    const updatedProperties = [...properties];
    if (updatedProperties[idx].isToggle) {
      value = e?.target?.value;
    } else {
      value = e?.target?.value?.replace(/[^0-9.]/g, "");
    }

    updatedProperties[idx].value = value;
    setProperties(updatedProperties);
    setShowSave(true);
  };

  const handleChangeSelect = (e, idx) => {
    let value;

    const updatedProperties = [...properties];
    if (updatedProperties[idx].isToggle) {
      value = e;
    } else {
      value = e?.replace(/[^0-9.]/g, "");
    }

    updatedProperties[idx].value = value;
    setProperties(updatedProperties);
    setShowSave(true);
  };

  const handleSave = () => {
    let updatedData = properties.reduce((acc, property) => {
      if(property.property === "fba_inbound_placement_service" && !property.value) return acc;
      acc[property.property] = property?.title?.includes(getCurrency(settings.marketplace))
        ? parseFloat(property.value).toFixed(2) || "0.00"
        : property.value || "0";
      return acc;
    }, {});

    // update the data object
    data = { ...data, ...updatedData };

    handleUpdate(data);
    setShowSave(false);
  };

  const handleCancel = () => {
    setProperties(createPropertiesFromData(data));
    setShowSave(false);
  };

  useEffect(() => {
    setProperties(createPropertiesFromData(data));
  }, [data]);

  const createPropertiesFromData = (data) => {
    return [
      {
        title: `FBM Cost(${getCurrency(settings.marketplace)})`,
        value: data?.fbm_cost || "0.00",
        property: "fbm_cost",
        text: "FBM Cost is the cost you want to set for the product.",
      },
    //   {
    //     title: "Custom ROI(%)",
    //     value: data?.custom_roi || "0.00",
    //     property: "custom_roi",
    //     text: "Custom ROI is the ROI you want to set for the product.",
    //   },
      {
        title: "Storage Time (months)",
        value: data?.storage_time || "0",
        property: "storage_time",
        text: "Storage Time is the time you want to set for the product.",
      },
      {
        title: "Local Fulfillment (FBA/FBM)",
        value: data?.local_fullfillment || "FBA",
        property: "local_fullfillment",
        text: "Local Fulfillment is the type of fulfillment you want to set for the product.",
        isToggle: true,
        type: "select",
      },
      {
        title: "European Fulfillment (EFN/Pan EU)",
        value: data?.europian_fullfillment || "EFN",
        property: "europian_fullfillment",
        text: "Default European fulfillment process (EFN/PanEU) for calculations. This can be manually adjusted as you analyze.",
        isToggle: true,
        type: "select",
      },
    ];
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleFocus = (idx) => {
    const input = inputRefs.current[idx];
    const valueLength = properties[idx].value.length;
    input.setSelectionRange(valueLength, valueLength);
  };

  return (
    <div
      className="flex flex-col w-full border-primary bg-primary-bg p-4 mt-4 border border-border/100 rounded-2xl"
    >
      <div
        className="flex cursor-pointer items-center mb-2"
        onClick={toggleAccordion}
      >
        <div
          className="mr-1 text-primary font-bold"
          style={{
            fontSize: "16px",
          }}
        >
          Fulfillment & Storage Settings
        </div>
        <div>{/* {isOpen ? <FaAngleUp /> : <FaAngleDown />} */}</div>
      </div>
      {isOpen && (
        <>
          {properties.map((property, index) => (
            <div
              key={index}
              className={`${
                property?.isToggle ? "" : "flex"
              } text-white justify-between bg-secondary-dark p-4 rounded-lg align-center mb-2`}
              style={{
                fontSize: "13px",
              }}
            >
              <div
                className={`${
                  property?.isToggle ? "w-full" : "w-3/4"
                } flex items-center`}
                style={{ textAlign: "left" }}
              >
                <span
                  style={
                    {
                      // maxWidth: "68%"
                    }
                  }
                >
                  {property.title}
                </span>
                <Tooltip text={property.text} />
              </div>
              <div className="">
                {property.isToggle && property.type === "days" ? (
                  <Select
                    inputValue={property?.value}
                    handleDropdownChange={(e) => handleChangeSelect(e, index)}
                    dropdownOptions={[
                      "Current",
                      "30 Days",
                      "90 Days",
                      "180 Days",
                      "All",
                    ]}
                  />
                ) : property.isToggle && property.type === "select" ? (
                  <Select
                    inputValue={property?.value}
                    handleDropdownChange={(e) => handleChangeSelect(e, index)}
                    dropdownOptions={property.property === 'local_fullfillment' ? local_dropdownOptions : euro_dropdownOptions}
                  />
                ) : (
                  <input
                    type="text"
                    value={`${property.title.includes(getCurrency(settings.marketplace)) ? getCurrency(settings.marketplace) : ""}${
                      property?.value
                    }${property.title.includes("%") ? "%" : ""}`}
                    onChange={(e) => handleChange(e, index)}
                    onFocus={() => handleFocus(index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                    placeholder={`${getCurrency(settings.marketplace)}20`}
                    className={`text-center text-white border border-primary rounded-xl bg-primary-dark max-w-[20vw]`}
                    style={{
                      borderRadius: "12px",
                    }}
                  />
                )}
              </div>
            </div>
          ))}
          {showSave && (
            <SaveButtons handleSave={handleSave} handleCancel={handleCancel} />
          )}
        </>
      )}
    </div>
  );
};

export default FulfillmentandStorage;
